var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoaderLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 167,
    height: 110,
    viewBox: "0 0 167 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2783 109.996H0V43.8347L27.3098 71.1445",
    fill: "#095D7E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M109.46 0V35.0676L54.052 90.5071L27.2783 63.7334L0 36.4551V0.788389H4.22577L53.8312 50.3938L104.194 0H109.46Z",
    fill: "#14967F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M115.395 31.441C118.58 31.7248 121.481 32.6708 124.004 34.4053C127 36.4236 129.27 39.2302 130.878 42.7938L166.608 43.1722C165.158 34.5945 162.162 27.0891 157.589 20.6243C153.016 14.1595 147.056 9.14531 139.708 5.55026C132.581 2.04981 124.445 0.220749 115.395 0V31.4094V31.441Z",
    fill: "#095D7E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M123.562 75.7797C120.535 77.7349 117.098 78.681 113.219 78.6495C107.511 78.5864 103.033 76.4104 99.7847 72.0901C96.978 68.4004 95.4958 63.5439 95.149 57.7098L67.8076 84.8304C72.0018 92.3674 77.7729 98.3592 85.1837 102.743C93.1937 107.473 102.623 109.87 113.534 109.996C122.9 110.09 131.289 108.419 138.7 104.982C146.11 101.544 152.165 96.6563 156.864 90.2861C161.563 83.9159 164.716 76.4735 166.325 67.9274L130.595 67.5489C128.924 71.0809 126.59 73.8561 123.562 75.8113V75.7797Z",
    fill: "#095D7E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderLogo);
export default __webpack_public_path__ + "static/media/loader-logo.6e00291d0e25277434ab4d0bae9b66a2.svg";
export { ForwardRef as ReactComponent };